import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Your Firebase configuration from Firebase Console
const firebaseConfig = {
  apiKey: "AIza5yPhjnz_rBQymaAcGmJBcdxvdmY_KaM",
  authDomain: "mystore.firebaseapp.com",
  projectId: "mystore",
  storageBucket: "mystore.firebasestorage.app",
  messagingSenderId: "488156230986",
  appId: "1:488156230986:web:9f9d637ac38e2642f483e",
  measurementId: "G-JM7SQFCGxA"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (error) {
  console.error('Firebase messaging not supported:', error);
}

export { messaging, getToken, onMessage };
